import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
export function BonusSection() {
  const bonuses = ['Cartas imprimibles de posturas', 'Calendario de hábitos felices', 'Meditaciones guiadas para dormir', 'Yoga en familia', 'Juegos de respiración consciente', 'Rutinas anti pantallas'];
  return <section className="py-20 relative overflow-hidden bg-gradient-to-b from-amber-50 to-pastel-yellow/20" data-id="element-29">
      {/* Golden glow decorations */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-amber-300/20 blur-[100px] rounded-full pointer-events-none" data-id="element-30"></div>

      <div className="container mx-auto px-5 sm:px-8 lg:px-12 relative z-10" data-id="element-31">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-32">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-100 text-amber-700 font-bold text-sm mb-6 uppercase tracking-wider border border-amber-200 shadow-sm" data-id="element-33">
            <Sparkles size={16} data-id="element-34" />
            <span data-id="element-35">Regalo Exclusivo • Solo Hoy</span>
            <Sparkles size={16} data-id="element-36" />
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-6" data-id="element-37">
            Llevate estos <span className="text-amber-500" data-id="element-38">6 BONUS GRATIS</span>{' '}
            con tu compra hoy
          </h2>
          <p className="text-lg text-gray-600" data-id="element-39">
            Complementos perfectos para potenciar los resultados del kit
            principal.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-40">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgb(251,191,36,0.15)] border border-amber-100 flex items-start gap-4 hover:shadow-[0_8px_30px_rgb(251,191,36,0.25)] transition-shadow duration-300" data-id="element-41">
              <div className="w-12 h-12 shrink-0 rounded-full bg-amber-100 flex items-center justify-center text-amber-500" data-id="element-42">
                <Gift size={24} data-id="element-43" />
              </div>
              <div data-id="element-44">
                <div className="text-xs font-bold text-amber-500 uppercase tracking-wider mb-1" data-id="element-45">
                  Bono {index + 1}
                </div>
                <h3 className="font-display font-bold text-gray-800 leading-tight" data-id="element-46">
                  {bonus}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-47">
          <p className="text-xl font-bold text-gray-800 mb-2" data-id="element-48">
            Valor real de los bonus:{' '}
            <span className="line-through text-gray-400 decoration-red-400 decoration-2" data-id="element-49">
              ARS $25.000
            </span>
          </p>
          <p className="text-2xl font-display font-bold text-amber-600" data-id="element-50">
            HOY: TOTALMENTE GRATIS
          </p>
        </div>
      </div>
    </section>;
}